import {
  type ConnectToCrmWidgetValue,
  type ContactCrmFields,
  type CrmObject,
  ObjectTypes,
} from '@playbooks/core/src/interfaces/ConnectToCrmWidget'

function mapConnectorWidgetValue(data: CrmObject[]) {
  return (
    data.map<ConnectToCrmWidgetValue>(obj => ({
      id: obj.id,
      name: obj.objectType === ObjectTypes.contact ? getContactFullName(obj.crmFields) : obj.crmFields.Name,
      url: obj.url,
      type: obj.objectType,
      mail: (obj.crmFields as ContactCrmFields)?.Email,
    })) || []
  )
}

export function getContactFullName(crmFields: ContactCrmFields): string {
  return `${crmFields.FirstName || ''} ${crmFields.LastName || ''}`.trim()
}

export default mapConnectorWidgetValue
